import React from "react";
import { useTranslation } from "react-i18next";
import CashIcon from "assets/images/icons/cash.svg";
import { orderSpaceType } from "components/constants/DropdownOptions";
import { formatDate } from "components/common/Utils";
import RewardLevelProgress from "./RewardLevelProgress";
import Riyal from "assets/images/icons/riyal.svg";

const CurrentRewardLevel = ({ cashbackLevels, walletInfo }) => {
  const { t } = useTranslation();

  const rewardBottomData = [
    {
      key: "totalCashback",
      label: "Total Cashback",
      value: walletInfo?.totalCredit,
    },
    {
      key: "totalUnused",
      label: "Total Unused",
      value: Number(
        (
          (walletInfo?.totalCredit ?? 0) - (walletInfo?.totalDebit ?? 0)
        )?.toFixed(2)
      ),
    },
    {
      key: "totalUsed",
      label: "Last Used",
      value: formatDate(walletInfo?.lastDebitDate) || "-",
    },
  ];

  return (
    <div className="common_card_inner reward_div">
      <h2 className="fs_20">{t("Current Reward Level")}</h2>

      <div className="d-flex gap-3">
        {cashbackLevels?.map((item) => (
          <>
            <RewardCard t={t} item={item} />
          </>
        ))}
      </div>
      <div>
        <div className="d-flex gap-5 mt-3">
          {rewardBottomData?.map((item, index) => (
            <div key={index}>
              <h2 className="fs_14 text_gray">{item?.label}</h2>
              <h3
                className={`${
                  ["totalCashback", "totalUnused"]?.includes(item?.key)
                    ? "fs_24"
                    : "fs_14 text_gray mt-2"
                } `}
              >
                {["totalCashback", "totalUnused"]?.includes(item?.key) && (
                  <img
                    src={Riyal}
                    width={20}
                    height={20}
                    alt="riyal"
                    className="me-1"
                  />
                )}
                {item?.value}{" "}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CurrentRewardLevel;

const RewardCard = ({ t, item }) => {
  const reachWorkspaceBooking =
    item?.levels[item?.currentLevel + 1 - 1]?.value - item?.numberOfBookings;
  const reachMeetingRoomBooking =
    item?.levels[item?.currentLevel + 1 - 1]?.value - item?.durationOfBookings;

  const getProgressWidth = (currentLevel, totalLevels) => {
    if (currentLevel <= 0) return "0%";
    if (currentLevel >= totalLevels - 1) return "100%";

    const step = 100 / (totalLevels - 1);
    const progress = step * currentLevel;

    return `${progress.toFixed(1)}%`;
  };

  return (
    <div className="workspace-card">
      <div className="d-flex justify-content-between">
        <span className="fs_14">
          {
            orderSpaceType?.find(
              (option) => option.value === item?.cashbackTypeInt
            )?.name
          }
        </span>
        <span className="fs_12 text_gray">
          {t("Cycle")} {item?.currentCycle}
        </span>
      </div>

      <div className="cashback-box mb">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <img src={CashIcon} width={24} height={24} alt="" />
            <p className="fs_14 text_primary">
              {
                item?.levels[
                  item?.currentLevel === 0 ? 0 : item?.currentLevel - 1
                ]?.cashbackPercentage
              }{" "}
              % <span className="text_black"> {t("Cashback")}</span>
            </p>
          </div>
          <span className="fs_12 text_gray">
            {t("Ends on")} {formatDate(item?.cycleExpiredIn)}
          </span>
        </div>

        {(() => {
          // Normalize levels by taking difference with previous level
          const levels = item.levels.map((level, index, arr) => {
            const prevValue = index === 0 ? 0 : arr[index - 1].value;
            return { steps: level.value - prevValue };
          });

          // Get achieved steps = value of current level
          // const achievedSteps = item.levels[item.currentLevel - 1]?.value || 0;
          const achievedSteps =
            item?.cashbackTypeInt === 1
              ? item?.numberOfBookings
              : item?.durationOfBookings;

          return (
            <RewardLevelProgress
              levels={levels}
              achievedSteps={achievedSteps}
              currentLevel={item?.currentLevel}
            />
          );
        })()}

        {/* <div className="progress-line mt-3 position-relative">
          <div
            className="progress_line_filled"
            style={{
              width: getProgressWidth(item?.currentLevel, item?.levels?.length),
            }}
          ></div>
          {item?.levels?.map((level, index) => (
            <div
              className={`progress-step ${
                item?.currentLevel >= index + 1 ? "active" : ""
              } `}
            />
          ))}
        </div> */}
        <div className="mt-3">
          <h2 className="fs_12 text_gray">
            {item?.cashbackTypeInt === 1 ? t("Total Bookings") : t("Total Hours")}
            :{" "}
            <strong>
              {item?.cashbackTypeInt === 1
                ? item?.numberOfBookings
                : item?.durationOfBookings}
            </strong>
          </h2>
          <div className="g_between gap-3">
            {/* SHOW FOR WORKSPACE */}
            {item?.cashbackTypeInt === 1 &&
              (item?.currentLevel === item?.levels?.length ? (
                <h2 className="fs_12 text_gray">
                  {t("Maximum Levels Achieved")}
                </h2>
              ) : (
                <h2 className="fs_12 text_gray">
                  {reachWorkspaceBooking} {t("bookings to reach level")}{" "}
                  {item?.currentLevel + 1}
                </h2>
              ))}
            {/* SHOW FOR MEETING ROOM */}
            {item?.cashbackTypeInt === 2 &&
              (item?.currentLevel === item?.levels?.length ? (
                <h2 className="fs_12 text_gray">
                  {t("Maximum Levels Achieved")}
                </h2>
              ) : (
                <h2 className="fs_12 text_gray">
                  {reachMeetingRoomBooking} {t("hours to reach level")}{" "}
                  {item?.currentLevel + 1}
                </h2>
              ))}
            <h2 className="fs_10 text_gray">
              {t("Last Booking on")}: {formatDate(item?.lastOrderDate)}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};
